console.log('ver.22.1')
import { createApp, ref } from 'vue'
import App from './App.vue'
//import router from './router'
import VueGtag from 'vue-gtag'
import { VueCookieNext } from 'vue-cookie-next'
import '@/assets/css/main.css'

// Patch to prevent Google Ads Vignette from setting aria-hidden="true" on body
// This fixes the "Blocked aria-hidden on a <body> element" console error
if (typeof document !== 'undefined' && document.body) {
  try {
    const originalSetAttribute = document.body.setAttribute
    document.body.setAttribute = function (name, value) {
      if (name === 'aria-hidden') {
        return
      }
      originalSetAttribute.call(this, name, value)
    }
  } catch (e) {
    // console.warn('Failed to apply aria-hidden patch', e)
  }
}

const app = createApp(App);
//app.use(router);
app.use(VueCookieNext);
app.use(VueGtag, {
  config: { id: 'G-K0L44VQQL0' },
  //router,
  enabled: true,
});

app.provide('gtag', app.config.globalProperties.$gtag);


app.mount('#app');







//createApp(App).mount('#app')

require('./assets/js/top-menu-icon.js')

